/**
 * 來賓預定票券相關的資訊
 */

import * as actionTypes from '@/actionTypes';

const state = {
  /**
   * {
   *   ticketTypes: {
   *    "[ticketTypeUuid]": {
   *       sessions: [],
   *       quantity: 1,
   *     }
   *   }
   * }
   */
  signingUpTicketInfo: {
    ticketTypes: {},
  },
  guestSelectSessionUuids: [],
};

function clientOrderReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.SET_GUEST_SIGN_UP_INFO:
      return {
        ...globalState,
        signingUpTicketInfo: action.data,
      };
    case actionTypes.SET_GUEST_SELECT_SESSIONS:
      return {
        ...globalState,
        guestSelectSessionUuids: action.data,
      };
    default:
      return globalState;
  }
}

export { clientOrderReducer as default };
